import { getLocalTranslation } from '../../utils/i18nKit';
export var getTripartiteCooperationProductStatusMap = function getTripartiteCooperationProductStatusMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    active: {
      label: $t('kit:quotes.active'),
      value: 'active'
    },
    inactive: {
      label: $t('kit:quotes.inactive'),
      value: 'inactive'
    }
  };
};
export var getTripartiteCooperationProductStatusList = function getTripartiteCooperationProductStatusList() {
  return Object.values(getTripartiteCooperationProductStatusMap());
};